import React from 'react';

const logos = [
  {
    src: '/nvidia-inception-logo.svg',
    alt: 'NVIDIA Inception',
    label: 'NVIDIA Inception',
    sub: 'Member program',
  },
  {
    src: '/Activate.svg',
    alt: 'AWS Activate',
    label: 'AWS Activate',
    sub: 'Cloud partner',
  },
  {
    src: '/Amazon_Web_Services_Logo.svg',
    alt: 'Amazon Web Services',
    label: 'Amazon Web Services',
    sub: 'Infrastructure',
  },
  {
    src: '/USCC_Webstickers_2022_234x75.png',
    alt: 'U.S. Chamber of Commerce Member',
    label: 'U.S. Chamber of Commerce',
    sub: 'Member',
  },
];

export default function Partners() {
  return (
    <section className="relative">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 py-20 lg:py-24">
        <div className="text-center max-w-[760px] mx-auto">
          <div className="text-[11.5px] tracking-[0.16em] uppercase text-[#1B6F5E] font-medium">
            Technology partners & innovation programs
          </div>
          <h2 className="mt-3 font-display text-[34px] lg:text-[44px] leading-[1.06] text-[#0B1F2D]">
            GPU-accelerated AI on secure cloud infrastructure
          </h2>
          <p className="mt-5 text-[15px] leading-[1.6] text-[#0B1F2D]/65">
            ESGine® participates in NVIDIA Inception and AWS Activate, combining GPU-accelerated AI with secure AWS
            cloud infrastructure to power ESG-as-Code® compliance evaluations.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-5">
          {logos.map((logo) => (
            <div
              key={logo.label}
              className="rounded-2xl border border-[#E8E5DC] bg-white px-6 py-7 flex flex-col items-start justify-between min-h-[140px]"
            >
              <div className="h-12 flex items-center">
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="h-10 w-auto object-contain max-w-[160px]"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <span
                  className="font-display text-[18px] text-[#0B1F2D] leading-tight hidden"
                >
                  {logo.label}
                </span>
              </div>
              <div className="mt-4 text-[11px] uppercase tracking-[0.12em] text-[#0B1F2D]/55">{logo.sub}</div>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-[11.5px] leading-[1.6] text-[#0B1F2D]/45 max-w-[820px] mx-auto">
          NVIDIA, the NVIDIA logo, and NVIDIA Inception are trademarks of NVIDIA Corporation. AWS, Amazon Web Services
          and the AWS logo are trademarks of Amazon Web Services, Inc. or its affiliates.
        </p>
      </div>
    </section>
  );
}
